define('NVT.membershipdirectory.Collection',
  [
  'Backbone'
  ,'NVT.membershipdirectory.membershipdirectory.Model'
  ,'underscore'
  ,'Utils'
  ],
  function (Backbone, membershipdirectoryModel, _,Utils) {
    return Backbone.Collection.extend({
      model: membershipdirectoryModel,
      cacheSupport: false,
      url : function () {
          return Utils.getAbsoluteUrl(
              getExtensionAssetsPath(
                  "Modules/membershipdirectory/SuiteScript2/membershipdirectory.Service.ss"
              ), true
          )
      }

      , initialize: function () {
          this.on('add', function(model) {

          });
          this.on('remove',  function(model) {

          });
          this.on('change', function(model) {
            
          });
          this.on('reset', function(model) {
          
        });
      }

      ,	parse: function (response)
      {
          this.totalRecordsFound = response.totalRecordsFound;
          this.recordsPerPage = response.recordsPerPage;
          this.showMembershipNumber = response.showMembershipNumber;
          this.showCompany = response.showCompany;
          this.showUENNO = response.showUENNO;
          this.showIndustryGroupList = response.showIndustryGroupList;
          this.page = response.page;
          return response.records;
      }    
      
    ,  update: function update(options, callbacks) {
        return this.fetch(
            _.extend(
                {
                    data: {
                      page: options.page,
                      pageSize :  options.pageSize,
                      MembershipNumber : options.data.MembershipNumber,
                      Company :   options.data.Company,
                      UENNO :  options.data.UENNO,
                      IndustryGroup :  options.data.IndustryGroup,
                      recordsPerPage: options.data.recordsPerPage
                    },
                    reset: !!options.reset,
                    killerId: options.killerId
                },
                callbacks
            ), this.trigger('reset')
        );

        
    }

    });
  }
);
